import owd from 'owd/owd';
import 'lib/jszip.min';
import 'lib/jszip-utils';
import FileSaver from 'file-saver/FileSaver.min.js'; 

export default class Files extends owd.Component {
	init() {
        this.buttonDownload = $('.files-download');
		this.bind();
	}
    
    urlToPromise(url) {
        return new Promise(function(resolve, reject) {
            JSZipUtils.getBinaryContent(url, function (err, data) {
                if(err) {
                    reject(err);
                } else {
                    resolve(data);
                }
            });
        });
    }

	bind() {
        this.on('click', this.buttonDownload, (e) => {
            e.preventDefault();
            
            const zip = new JSZip();
            
            this.$element.find(':checked').each((i, el) => {
                el = $(el);
                
                const url = el.data('file');
                const fileName = url.replace(/.*\//g, "");
                
                zip.file(fileName, this.urlToPromise(url), {binary: true});
            });
            
            zip.generateAsync({type:"blob"}).then(function(content) {
                // Force down of the Zip file
                FileSaver.saveAs(content, "raport.zip");
            });

        });
    }

    destroy() {
        super.destroy();
    }
}

owd.registerComponent('files', {
	component: Files
});
